export const InvalidGamePlayMessage = () => (
  <div>
    <p>Non riusciamo a risalire al tuo ruolo o al team di appartenenza.</p>
    <p>
      Prova a verificare di aver usato il link corretto per raggiungere questa
      pagina.
    </p>
  </div>
);
